var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { format, formatDistance } from 'date-fns';
import ptBrLocale from 'date-fns/locale/pt-BR';
import EmptyMessage from '@/components/EmptyMessage.vue';
import { Component, Vue } from 'vue-property-decorator';
import { cancelExportation, getExportEvents, } from '@/clients/info_set';
import { NotificationService } from '@/services/NotificationService';
import Pagination from '@/components/Pagination.vue';
let InfosetsExportationsContainer = class InfosetsExportationsContainer extends Vue {
    constructor() {
        super(...arguments);
        this.exportations = [];
        this.rowTab = 'summary';
        this.page = 1;
        this.totalPages = 0;
        this.columnsList = [
            {
                name: 'date',
                label: 'Data de solicitação',
                align: 'left',
                field: 'date',
            },
            {
                name: 'infoset',
                label: 'Nome da Lista',
                align: 'left',
                field: 'infoset',
            },
            {
                name: 'service',
                label: 'Destino',
                align: 'left',
                field: 'service',
            },
            {
                name: 'companies',
                label: 'Empresas',
                align: 'center',
                field: 'companies',
            },
            {
                name: 'status',
                label: 'Status',
                align: 'left',
                field: 'status',
            },
        ];
    }
    async mounted() {
        await this.fetchEvents();
        this.interval = setInterval(() => this.fetchEvents(), 5000);
    }
    beforeDestroy() {
        clearInterval(this.interval);
    }
    async fetchEvents() {
        try {
            const response = await getExportEvents(this.page);
            this.totalPages = Math.ceil(response.data.total / 10);
            this.exportations = response.data.events.map((e, index) => ({
                index,
                date: this.getDistanceDateFromToday(e.created_at),
                tab: `summary-${e.id}`,
                ...e,
            }));
        }
        catch (e) {
            console.log(e);
        }
    }
    getDistanceDateFromToday(date) {
        const today = new Date();
        const eventDate = new Date(date);
        return formatDistance(eventDate, today, {
            addSuffix: true,
            includeSeconds: true,
            locale: ptBrLocale,
        });
    }
    getExportationStatusColor(row) {
        switch (row.status) {
            case 'export_companies_initialized':
                return 'grey';
            case 'export_companies_in_progress':
                return 'yellow';
            case 'export_companies_error':
                return 'red';
            case 'export_companies_cancelled':
                return 'grey';
            case 'export_companies_completed':
                return 'green';
            default:
                return 'grey';
        }
    }
    getExportationStatus(row) {
        switch (row.status) {
            case 'export_companies_initialized':
                return 'Inicializado';
            case 'export_companies_in_progress':
                return 'Em andamento';
            case 'export_companies_cancelled':
                return 'Cancelado';
            case 'export_companies_error':
                return 'Erro';
            case 'export_companies_completed':
                return 'Finalizado';
            default:
                return 'Inicializado';
        }
    }
    getProgressPercentage(row) {
        let total = 0;
        let processed = 0;
        if (row.service.includes('excel') || row.service.includes('csv')) {
            if (row.statistics && row.statistics.totals)
                if (row.service.includes('email')) {
                    total = row.statistics.totals.emails || 0;
                }
                else if (row.service.includes('decisors')) {
                    total = row.statistics.totals.decisors || 0;
                }
                else {
                    total = row.statistics.totals.companies || 0;
                }
            if (row.statistics && row.statistics.processed) {
                const companies = row.statistics.processed.companies || 0;
                const rows = row.statistics.processed.rows || 0;
                if (row.service === 'excel-email') {
                    processed = rows;
                }
                else {
                    processed = companies + rows;
                }
            }
        }
        else {
            if (!!row.statistics &&
                !!row.statistics.processed &&
                !!row.statistics.processed.companies &&
                !!row.statistics.processed.decisors) {
                total =
                    (row.statistics.totals.companies || 0) +
                        (row.statistics.totals.decisors || 0);
                processed =
                    (row.statistics.processed.companies || 0) +
                        (row.statistics.processed.decisors || 0);
            }
            else {
                total = 0;
                processed = 0;
            }
        }
        if (total === 0)
            return 0;
        if (row.service === 'excel-email') {
            return Math.ceil(processed / (total / 100)) || 0;
        }
        return Math.round((processed / total) * 100) || 0;
    }
    getExportationTime(row) {
        return format(new Date(row.created_at), 'HH:mm');
    }
    getExportationDate(row) {
        return format(new Date(row.created_at), 'dd/MM/yyyy');
    }
    getExportationAuthor(row) {
        return row.user && row.user[0] ? row.user[0].name : '';
    }
    totalCompaniesWithSuccess(row) {
        return row.counting_successful_companies;
    }
    totalCompaniesWithErrors(row) {
        return row.count_of_companies_with_errors;
    }
    handleInfosetName(row) {
        return row.info_set.name;
    }
    totalDecisorsWithErrors(row) {
        return row.count_of_decisors_with_errors;
    }
    async cancelExportation(eventId) {
        this.$q
            .dialog({
            title: 'Confirmar cancelamento',
            message: 'Tem certeza que deseja cancelar o processo de exportação?',
            cancel: {
                flat: true,
                label: 'Não',
                color: 'grey-7',
            },
            ok: {
                unelevated: true,
                label: 'Sim, cancelar',
                color: 'negative',
            },
            persistent: true,
        })
            .onOk(async () => {
            try {
                await cancelExportation(eventId);
                NotificationService.success('Sucesso', 'Exportação cancelada!');
            }
            catch (e) {
                NotificationService.error('Erro', 'Não foi possível cancelar esta exportação!');
            }
        });
    }
    exportationCompanies(row) {
        if (row.statistics && row.statistics.totals)
            return row.statistics.totals.companies;
    }
    shouldShowProgress(row) {
        const status = ![
            'export_companies_cancelled',
            'export_companies_completed',
            'export_companies_error',
        ].includes(row.status);
        return status;
    }
    setPage(page) {
        this.page = page;
        this.fetchEvents();
    }
};
InfosetsExportationsContainer = __decorate([
    Component({
        components: {
            EmptyMessage,
            Pagination,
        },
    })
], InfosetsExportationsContainer);
export default InfosetsExportationsContainer;
